import { apiClient } from "helpers/api_helper"

export const GetAllCustomerData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Customer/GetAllCustomerGrid`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getCustomerById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/customer/GetCustomerDetailsById?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getCustomerByMobileNo = async (num: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Customer/GetCustomerByMobileNo?mobileNo=${num}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createCustomer = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Customer/InsertCustomer', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateCustomer = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/customer/UpdateCustomer', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteCustomer = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/customer/DeleteCustomer?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};